import { useMediaQuery } from "@mui/material";
import React from "react";
import { ref } from "../components/SmallComponents/Images";

export default function AsFeaturedIn() {
  const matches = useMediaQuery("(max-width:700px)");
  return (
    <div className="featubox">
      <div style={{ marginTop: matches ? "-100px" : "10px", display: "flex", justifyContent: "center" }} className="container">
        <a
          href="referral.pdf"
          target="_blank"
        >
          <img height={matches ? "100%" : "180px"} width={matches ? "100%" : "728px"} src={ref} alt="" />
        </a>
      </div>
    </div>
  );
}
